import PubSub from 'underpub-js';
import mapboxgl from 'mapbox-gl';
import * as turf from 'turf';
import ImgixClient from "@imgix/js-core";

const client = new ImgixClient({
  domain: 'priyaliving.imgix.net',
});

var Map = function (options) {
  this.options = {
    $el: false,
    baseClass: 'el-Map',
    settings: {
      style: 'mapbox://styles/authenticff/ckynr7sad1j1814lxc85ozkls',
      center: [-96, 40],
      zoom: 12,
    },
  };

  $.extend(true, this.options, options);
};

Map.prototype.init = function () {
  const self = this;

  self.$map = self.options.$el;
  self.id = self.options.$el.attr('id');
  self.data = window[`MapData_${self.id}`]
  self.zoom = self.data.zoom;
  self.geoJson = self.data.geoJson;
  self.features = self.geoJson.features;
  self.featuredFeature = self.geoJson.features.filter(f => f.properties.isFeatured == true)[0] || null;

  if (typeof self.zoom === "number") {
    self.options.settings.zoom = self.zoom;
  }

  if (typeof self.featuredFeature !== "undefined") {
    self.options.settings.center = self.featuredFeature.geometry.coordinates;
  } else if (typeof self.features !== "undefined" && self.features.length) {
    self.options.settings.center = self.features[0].geometry.coordinates;
  }

  self.initMap();
};

Map.prototype.initMap = function () {
  const self = this;

  if (!self.features.length) return;

  mapboxgl.accessToken =
    'pk.eyJ1IjoiYXV0aGVudGljZmYiLCJhIjoiUmtjWTY2byJ9.QeHZuWdaMRJlobq_RgXngw';

  self.map = new mapboxgl.Map({
    container: self.id,
    style: self.options.settings.style,
    zoom: self.options.settings.zoom,
    center: self.options.settings.center,
  });

  const boundingBox = turf.bbox({
    type: 'FeatureCollection',
    features: self.features,
  });

  self.map.scrollZoom.disable();
  self.map.doubleClickZoom.disable();
  this.map.addControl(new mapboxgl.NavigationControl());

  const boundingBoxPaddingValue = $(window).width() >= 768 ? 200 : 100;
  const boundingBoxPadding = {
    top: boundingBoxPaddingValue,
    bottom: boundingBoxPaddingValue,
    left: boundingBoxPaddingValue,
    right: boundingBoxPaddingValue,
  };


  if (self.features.length > 1) {
    self.map.fitBounds(boundingBox, {
      center: self.options.settings.center,
      padding: boundingBoxPadding,
      zoom: self.options.settings.zoom,
    });
  } else if (self.features.length == 1) {
    self.map.flyTo({
      center: self.options.settings.center,
      zoom: self.options.settings.zoom,
    });
  }

  self.map.on('load', function () {

    self.features.forEach(feature => {
      const featureIcon = feature.properties.icon;

      if (typeof featureIcon === "object" && featureIcon !== null) {
        const featureIconPath = featureIcon.path;
        const featureIconTitle = featureIcon.title;
        let featureIconUrl;
        let featureIconImgixUrl;

        if (typeof featureIconPath === "string" && featureIconPath.length > 0) {
          featureIconImgixUrl = client.buildURL(`/images/${featureIconPath}`, {
            width: 40,
            height: 40,
          })
        }

        if (featureIconImgixUrl.length) {
          featureIconUrl = featureIconImgixUrl;
        } else {
          featureIconUrl = featureIcon.url;
        }

        if (typeof featureIconUrl === "string") {
          self.map.loadImage(featureIconUrl, (error, image) => {
            if (error) throw error;

            if (!self.map.hasImage(featureIconTitle)) {
              self.map.addImage(featureIconTitle, image);
            }
          })
        }
      }
    })

    self.map.addSource('locations', {
      type: 'geojson',
      data: self.geoJson,
      cluster: true,
      clusterMaxZoom: 10,
      clusterRadius: 50,
    });

    self.map.addLayer({
      id: 'clusters',
      type: 'circle',
      source: 'locations',
      filter: ['has', 'point_count'],
      paint: {
        'circle-color': [
          'step',
          ['get', 'point_count'],
          self.options.GLOBAL_VARIABLES.COLORS.QUINARY,
          20,
          self.options.GLOBAL_VARIABLES.COLORS.PRIMARY,
          50,
          self.options.GLOBAL_VARIABLES.COLORS.SECONDARY,
        ],
        'circle-opacity': ['step', ['get', 'point_count'], 1, 20, 1, 50, 1],
        'circle-radius': ['step', ['get', 'point_count'], 20, 20, 30, 50, 40],
      },
    });

    self.map.addLayer({
      id: 'cluster-count',
      type: 'symbol',
      source: 'locations',
      filter: ['has', 'point_count'],
      layout: {
        'text-field': '{point_count_abbreviated}',
        'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
        'text-size': ['step', ['get', 'point_count'], 12, 20, 15, 50, 18],
      },
      paint: {
        'text-color': [
          'step',
          ['get', 'point_count'],
          self.options.GLOBAL_VARIABLES.COLORS.WHITE,
          20,
          self.options.GLOBAL_VARIABLES.COLORS.BLACK,
          50,
          self.options.GLOBAL_VARIABLES.COLORS.WHITE,
        ],
      },
    });

    self.map.addLayer({
      id: 'unclustered-point',
      type: 'circle',
      source: 'locations',
      filter: [
        "all",
        ['!', ['has', 'point_count']],
        ['!=', ['get', 'isFeatured'], true]
      ],
      paint: {
        'circle-color': self.options.GLOBAL_VARIABLES.COLORS.QUINARY,
        'circle-opacity': 1,
        'circle-radius': 20,
      },
    });

    self.map.addLayer({
      id: 'unclustered-point-shadow',
      type: 'circle',
      source: 'locations',
      filter: [
        "all",
        ['!', ['has', 'point_count']],
        ['!=', ['get', 'isFeatured'], true]
      ],
      paint: {
        'circle-color': self.options.GLOBAL_VARIABLES.COLORS.QUINARY,
        'circle-opacity': 0.4,
        'circle-radius': 30,
      },
    });

    self.map.addLayer({
      id: 'unclustered-point-image',
      type: 'symbol',
      source: 'locations',
      layout: {
        'icon-image': ['get', 'title', ['get', "icon"]],
        'icon-size': .5,
      }
    });

    self.map.addLayer({
      id: 'unclustered-point-featured',
      type: 'circle',
      source: 'locations',
      filter: [
        "all",
        ['==', ['get', 'isFeatured'], true]
      ],
      paint: {
        'circle-color': self.options.GLOBAL_VARIABLES.COLORS.SECONDARY,
        'circle-opacity': 1,
        'circle-radius': 20,
      },
    });

    self.map.addLayer({
      id: 'unclustered-point-featured-shadow',
      type: 'circle',
      source: 'locations',
      filter: [
        "all",
        ['==', ['get', 'isFeatured'], true]
      ],
      paint: {
        'circle-color': self.options.GLOBAL_VARIABLES.COLORS.SECONDARY,
        'circle-opacity': 0.2,
        'circle-radius': 30,
      },
    });

    self.map.on('click', 'clusters', function (e) {
      const features = self.map.queryRenderedFeatures(e.point, {
        layers: ['clusters'],
      });
      const clusterId = features[0].properties.cluster_id;
      self.map
        .getSource('locations')
        .getClusterExpansionZoom(clusterId, function (err, zoom) {
          if (err) return;

          self.map.easeTo({
            center: features[0].geometry.coordinates,
            zoom: zoom,
          });
        });
    });

    self.map.on('click', ['unclustered-point-featured'], function (e) {
      const featuredMarker = e.features[0];
      const featuredMarkerCoordinates = featuredMarker.geometry.coordinates.slice();
      const featuredMarkerProperties = featuredMarker.properties;
      const popupClass = `${self.options.baseClass}__featuredMarker__popup`;
      const featuredMarkerImageUrl = featuredMarkerProperties.imageUrl;
      const featuredMarkerHeading = featuredMarkerProperties.heading;

      const popupMarkup = `<div class="${popupClass}">
        ${featuredMarkerImageUrl && featuredMarkerImageUrl.length > 0
          ? `<div class="${popupClass}__image">
              <div class="${popupClass}__image__spacer"></div>
              <div class="${popupClass}__image__inner" style="background-image: url(${featuredMarkerImageUrl})">
              </div>
            </div>`
          : ''}
        <div class="${popupClass}__content">
          <h5 class="${popupClass}__heading">
            ${featuredMarkerHeading}
          </h5>
        </div>
      </div>`;

      new mapboxgl.Popup({
          className: "featured-popup",
          closeButton: false,
        })
        .setLngLat(featuredMarkerCoordinates)
        .setOffset(15)
        .setHTML(popupMarkup)
        .addTo(self.map);

    });

    // self.features.forEach(feature => {
    //   const featureCoordinates = feature.geometry.coordinates;
    //   const featureProperties = feature.properties;
    //   const featureIconUrl = featureProperties.iconUrl;
    //   const iconClass = `${self.options.baseClass}__marker__icon`;

    //   const iconMarkup = `<div width="20px" height="20px" class="${iconClass}" style="background-image: url(${featureIconUrl})">
    //           </div>`;
    //   new mapboxgl.Popup({
    //       closeOnClick: false,
    //       closeButton: false,
    //       className: "icon-popup",
    //     })
    //     .setLngLat(featureCoordinates)
    //     .setOffset(0)
    //     .setHTML(iconMarkup)
    //     .addTo(self.map);
    // })

    self.map.on('click', ['unclustered-point'], function (e) {
      const marker = e.features[0];
      const markerCoordinates = marker.geometry.coordinates;
      const markerProperties = marker.properties;
      const popupClass = `${self.options.baseClass}__marker__popup`;
      const markerImageUrl = markerProperties.imageUrl;
      const markerHeading = markerProperties.heading;
      const markerCopy = markerProperties.copy;

      const popupMarkup = `<div class="${popupClass}">
        ${markerImageUrl && markerImageUrl.length > 0
          ? `<div class="${popupClass}__image">
              <div class="${popupClass}__image__spacer"></div>
              <div class="${popupClass}__image__inner" style="background-image: url(${markerImageUrl})">
              </div>
            </div>`
          : ''}
        <div class="${popupClass}__content">
          <h5 class="${popupClass}__heading">
            ${markerHeading}
          </h5>
          <p class="${popupClass}__copy">
            ${markerCopy}
          </p>
        </div>
      </div>`;

      new mapboxgl.Popup()
        .setLngLat(markerCoordinates)
        .setOffset(40)
        .setHTML(popupMarkup)
        .addTo(self.map);
    });

    self.map.on('mouseenter', 'clusters', function () {
      self.map.getCanvas().style.cursor = 'pointer';
    });

    self.map.on('mouseleave', 'clusters', function () {
      self.map.getCanvas().style.cursor = '';
    });
  });
};

export default Map;